<template>
  <div id="bottom-bar">
    <div id="header" class="bottom-bar__header">
      <div class="bottom-bar__header-surface">
        <div class="container-fluid px-3 px-md-4">
          <div class="row justify-content-between align-items-center">
          <div class="col-8 col-md-6">
            <a href="javascript:" class="text-decoration-none bottom-bar__brand" title="Acessar Home" @click="alterarRegional()">
              <div class="small bottom-bar__region">
                {{ regional.nome_regional }} - {{ regional.sigla_estado }}
              </div>
              <h2 class="title">Calendário CCB</h2>
            </a>
          </div>
          <div class="col-4 col-md-6 d-flex justify-content-end align-items-center bottom-bar__desktop-actions">
            <router-link to="/listas" class="icone-desktop not-decoration" active-class="active" role="listitem" aria-label="Listas">
              <span class="icone-text">Listas</span>
            </router-link>
            <router-link to="/presencas" class="icone-desktop not-decoration" active-class="active" role="listitem" aria-label="Notificações">
              <span class="icone-text">Presenças</span>
              <span class="n-notificacao" v-show="qtdNotificacao > 0">{{ qtdNotificacao }}</span>
            </router-link>
            <router-link to="/perfil" class="icone-desktop not-decoration" active-class="active" role="listitem" aria-label="Meu Perfil">
              <span class="icone-text">Perfil</span>
            </router-link>
            <router-link to="/regional" active-class="active" class="btn d-md-none bottom-bar__info-btn" role="listitem" aria-label="Quem somos">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-info-circle" width="22" height="22" viewBox="0 0 24 24" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0m9-3h.01"/><path d="M11 12h1v4h1"/></svg>
            </router-link>
          </div>
        </div>
        </div>
      </div>
    </div>

    <div class="text-center fixed-bottom d-md-none bottom-bar__mobile-shell">
      <div class="bottom-bar shadow-top position-relative" role="navigation">
        <div class="container-fluid px-0">
          <div class="row no-gutters align-items-center bottom-bar__mobile-list" role="list">
            <router-link to="/calendario" active-class="active" class="col icone-bar not-decoration px-0" role="listitem" aria-label="Calendário">
              <div aria-hidden="true" class="icone-bar__content">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="bottom-bar__icon" fill="currentColor" aria-hidden="true">
                  <path d="M19,2h-1V1c0-.552-.447-1-1-1s-1,.448-1,1v1H8V1c0-.552-.447-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5ZM5,4h14c1.654,0,3,1.346,3,3v1H2v-1c0-1.654,1.346-3,3-3Zm14,18H5c-1.654,0-3-1.346-3-3V10H22v9c0,1.654-1.346,3-3,3Zm0-8c0,.552-.447,1-1,1H6c-.553,0-1-.448-1-1s.447-1,1-1h12c.553,0,1,.448,1,1Zm-7,4c0,.552-.447,1-1,1H6c-.553,0-1-.448-1-1s.447-1,1-1h5c.553,0,1,.448,1,1Z"/>
                </svg>
                <div class="text-bottom">Calendário</div>
              </div>
            </router-link>
            <router-link to="/listas" active-class="active" class="col icone-bar not-decoration px-0" role="listitem" aria-label="Listas">
              <div aria-hidden="true" class="icone-bar__content">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="bottom-bar__icon" fill="currentColor" aria-hidden="true">
                  <path d="m19,1H5C2.243,1,0,3.243,0,6v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V6c0-2.757-2.243-5-5-5Zm3,17c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V6c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3v12Zm-3-11c0,.552-.448,1-1,1h-7c-.552,0-1-.448-1-1s.448-1,1-1h7c.552,0,1,.448,1,1Zm-11,0c0,.828-.672,1.5-1.5,1.5s-1.5-.672-1.5-1.5.672-1.5,1.5-1.5,1.5.672,1.5,1.5Zm11,5c0,.552-.448,1-1,1h-7c-.552,0-1-.448-1-1s.448-1,1-1h7c.552,0,1,.448,1,1Zm-11,0c0,.828-.672,1.5-1.5,1.5s-1.5-.672-1.5-1.5.672-1.5,1.5-1.5,1.5.672,1.5,1.5Zm11,5c0,.552-.448,1-1,1h-7c-.552,0-1-.448-1-1s.448-1,1-1h7c.552,0,1,.448,1,1Zm-11,0c0,.828-.672,1.5-1.5,1.5s-1.5-.672-1.5-1.5.672-1.5,1.5-1.5,1.5.672,1.5,1.5Z"/>
                </svg>
                <div class="text-bottom">Listas</div>
              </div>
            </router-link>
            <router-link to="/presencas" active-class="active" class="col icone-bar not-decoration px-0" role="listitem" aria-label="Presenças">
              <div aria-hidden="true" class="icone-bar__content">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="bottom-bar__icon" fill="currentColor" aria-hidden="true">
                  <path d="M23.259,16.2l-2.6-9.371A9.321,9.321,0,0,0,2.576,7.3L.565,16.35A3,3,0,0,0,3.493,20H7.1a5,5,0,0,0,9.8,0h3.47a3,3,0,0,0,2.89-3.8ZM12,22a3,3,0,0,1-2.816-2h5.632A3,3,0,0,1,12,22Zm9.165-4.395a.993.993,0,0,1-.8.395H3.493a1,1,0,0,1-.976-1.217l2.011-9.05a7.321,7.321,0,0,1,14.2-.372l2.6,9.371A.993.993,0,0,1,21.165,17.605Z"/>
                </svg>
                <span class="n-notificacao" v-show="qtdNotificacao > 0">{{ qtdNotificacao }}</span>
                <div class="text-bottom">Presenças</div>
              </div>
            </router-link>
            <router-link to="/perfil" active-class="active" class="col icone-bar not-decoration px-0" role="listitem" aria-label="Perfil">
              <div aria-hidden="true" class="icone-bar__content">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="bottom-bar__icon" fill="currentColor" aria-hidden="true">
                  <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-4,21.164v-.164c0-2.206,1.794-4,4-4s4,1.794,4,4v.164c-1.226.537-2.578.836-4,.836s-2.774-.299-4-.836Zm9.925-1.113c-.456-2.859-2.939-5.051-5.925-5.051s-5.468,2.192-5.925,5.051c-2.47-1.823-4.075-4.753-4.075-8.051C2,6.486,6.486,2,12,2s10,4.486,10,10c0,3.298-1.605,6.228-4.075,8.051Zm-5.925-15.051c-2.206,0-4,1.794-4,4s1.794,4,4,4,4-1.794,4-4-1.794-4-4-4Zm0,6c-1.103,0-2-.897-2-2s.897-2,2-2,2,.897,2,2-.897,2-2,2Z"/>
                </svg>
                <div class="text-bottom">Perfil</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottonBar',

  methods: {
    alterarRegional() {
      if (this.isCalendario) {
        this.$router.push('/perfil');

      } else if (this.$route.name !== 'Calendario') {
        this.$router.push('/calendario');
      }
    }
  },

  computed: {
    isCalendario() {
      return this.$route.name === 'Calendario';
    },

    regional() {
      return this.$store.state.dados.regional;
    },

    qtdNotificacao() {
      const qtd = this.$store.state.notificacoes.length;
      return qtd > 99 ? 99 : qtd;
    }
  },
}
</script>

<style scoped>
.bottom-bar__header {
  z-index: 9;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.42) 100%);
  border-bottom: 1px solid rgba(30, 51, 108, 0.08);
  backdrop-filter: blur(18px);
}

.bottom-bar__header-surface {
  margin: 0;
  min-height: 72px;
  padding: 14px 0 0;
  border-radius: 0;
  background: rgba(255, 255, 255, 0.58);
  border: none;
  box-shadow:  0 1px 2px rgba(20, 35, 70, 0.04), 0 6px 12px rgba(20, 35, 70, 0.08);
}

.bottom-bar__brand {
  display: block;
  color: var(--text-theme);
}

.bottom-bar__region {
  opacity: 0.82;
  letter-spacing: 0.015em;
  font-size: 12px;
  line-height: 1.2;
  color: var(--text-theme-secondary);
  margin-bottom: 4px;
}

.title {
  font-size: 1.05rem;
  font-weight: 800;
  margin-bottom: 0;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.bottom-bar__mobile-shell {
  z-index: 9;
  padding: 0;
}

.bottom-bar {
  background: linear-gradient(180deg, var(--bg-theme-secondary) 0%, var(--bg-elevated) 100%);
  border-top: 1px solid var(--border-color);
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 0;
  overflow: hidden;
  backdrop-filter: blur(18px);
  width: 100%;
  color: var(--text-theme);
}

.bottom-bar__mobile-list {
  min-height: 74px;
}

.icone-bar {
  position: relative;
  padding: 0;
  color: var(--text-theme-secondary);
  transition: transform 0.16s ease, color 0.16s ease;
  display: flex;
  min-height: 74px;
  align-items: stretch;
}

.icone-bar__content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 10px 0;
  border-radius: 0;
  transition: background-color 0.16s ease, box-shadow 0.16s ease;
  width: 100%;
}

.icone-bar.active {
  color: var(--primary);
}

.icone-bar.active .bottom-bar__icon {
  color: var(--secondary);
}

.icone-bar.active .icone-bar__content {
  background-color: transparent;
  box-shadow: none;
}

.icone-bar.active::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 3px;
  display: block;
  border-radius: 0;
  top: 0;
  left: 0;
  background-color: var(--secondary);
  z-index: 1;
}

.bottom-bar__icon {
  width: 18px;
  height: 18px;
  display: block;
  color: inherit;
}

.text-bottom {
  font-size: 11px;
  margin-top: 7px;
  font-weight: 500;
  letter-spacing: 0.01em;
  transition: color 0.16s ease, font-weight 0.16s ease;
}

.icone-bar.active .text-bottom {
  font-weight: 700;
}

.icone-desktop {
  padding: 10px 16px;
  color: var(--text-theme-secondary);
  margin-left: 8px;
  text-align: center;
  display: none;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 999px;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.34);
  transition: color 0.16s ease, background-color 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.icone-desktop .icone-text {
  white-space: nowrap;
  margin-left: 0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.icone-desktop:hover {
  color: var(--primary);
  background: rgba(255, 255, 255, 0.78);
  border-color: rgba(30, 51, 108, 0.08);
  box-shadow: 0 8px 22px rgba(20, 35, 70, 0.08);
}

.icone-desktop.active {
  color: var(--primary);
  font-weight: 700;
  background: rgba(251, 163, 1, 0.14);
  border-color: rgba(251, 163, 1, 0.22);
  box-shadow: 0 10px 22px rgba(244, 166, 58, 0.12);
}

.icone-desktop.active::before {
  display: none;
}

.n-notificacao {
  position: absolute;
  left: calc(50% + 12px);
  top: 3px;
  background: linear-gradient(180deg, var(--secondary-strong) 0%, var(--secondary) 100%);
  color: #1b1407!important;
  border-radius: 999px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  line-height: 11px;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(244, 166, 58, 0.24);
}

.bottom-bar__info-btn {
  min-width: 42px;
  min-height: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ios_platform .icone-bar {
  padding-bottom: 26px;
}

.icon-tabler {
  stroke: var(--primary);
}

@media (min-width: 768px) {
  .bottom-bar__header {
    padding-bottom: 0;
  }

  .bottom-bar__desktop-actions {
    gap: 4px;
  }

  .icone-desktop {
    display: flex;
  }

  .n-notificacao {
    top: 2px;
    left: auto;
    right: -6px;
  }

  .bottom-bar__mobile-shell {
    display: none;
  }
}

.dark-mode .bottom-bar__header {
  background: linear-gradient(180deg, rgba(14, 20, 32, 0.82) 0%, rgba(14, 20, 32, 0.56) 100%);
  border-bottom-color: rgba(124, 181, 230, 0.12);
}

.dark-mode .bottom-bar__header-surface {
  background: rgba(29, 42, 60, 0.72);
  border: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.22), 0 16px 32px rgba(0, 0, 0, 0.24);
}

.dark-mode .icone-desktop {
  background: rgba(255, 255, 255, 0.04);
}

.dark-mode .icone-desktop:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(124, 181, 230, 0.1);
}

.dark-mode .icone-desktop.active {
  background: rgba(244, 166, 58, 0.16);
  border-color: rgba(244, 166, 58, 0.22);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
}
</style>
